<template>
    <div ref="chart" class="pie-chart"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
    name: "PieChart",
    props: {
        data: {
            type: Array,
            default: () => []
        },
        colorArr: {
            type: Array,
            default: () => []
        },
        radius: {
            type: Array,
            default: () => ["40%", "70%"]
        },
    },
    data() {
        return {
            chart: null
        };
    },
    mounted() {
        this.initChart();
        window.addEventListener("resize", this.resizeChart);
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
        window.removeEventListener("resize", this.resizeChart);
    },
    watch: {
        data: {
            deep: true,
            handler() {
                this.updateChart();
            }
        }
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$refs.chart);
            this.setOption();
        },
        setOption() {
            const option = {
                tooltip: {
                    trigger: "item"
                },
                grid: {
                    top: 20,
                    bottom: 20,
                    left: 20,
                    containLabel: true
                },

                series: [
                    {
                        type: "pie",
                        radius: this.radius,
                        label: {
                            show: false,
                            position: "center"
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 20,
                                fontWeight: "bold"
                            }
                        },
                        data: this.data,

                        color: this.colorArr
                    }
                ]
            };
            this.chart.setOption(option);
        },
        updateChart() {
            if (this.chart) {
                this.setOption();
            }
        },
        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        }
    }
};
</script>

<style scoped>
.pie-chart {
    width: 200px;
    height: 200px;
}
</style>
